import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'
/* Router Modules */
import Login from '@/views/login/index'
import Error404 from '@/views/error-page/404'
import Error401 from '@/views/error-page/401'
import Dashboard from '@/views/dashboard/index'
import PaidMember from '@/views/member/index'
import PlayersDataList from '@/views/member/players-data-list'
import PlayerYearList from '@/views/member/player-years-list'
import PlayerGamesList from '@/views/member/player-games-list'
import PlayerGamesList2 from '@/views/member/player-games-list2'
import PlayerTeamsList from '@/views/member/player-teams-list'
import PlayerMatchesList from '@/views/member/player-matches-list'

import Settings from '@/views/system/settings'
import Admins from '@/views/system/admins'
import Roles from '@/views/system/roles'
import Fees from '@/views/system/fees'
import Schools from '@/views/system/schools'
import Protocols from '@/views/system/protocols/list'
import ProtocolM from '@/views/system/protocols/index'
import ProtocolEdit from '@/views/system/protocols/details'

import Users from '../views/user/users'
import Players from '../views/user/players/list'
import PlayerM from '../views/user/players/index'
import Player from '../views/user/players/details'
import CoachM from '../views/user/coaches/index'
import CoachEdit from '../views/user/coaches/details'
import Coaches from '../views/user/coaches/list'
import InRefereeM from '../views/user/referees/index'
import InReferee from '../views/user/referees/list'
import RefereeGameList from '../views/user/referees/game-list'
import RefereeMatchTypeList from '../views/user/referees/match-type-list'
import RefereeMatchList from '../views/user/referees/match-list'
import InRefereeEdit from '../views/user/referees/details'
import OutRefereeM from '../views/user/outReferees'
import OutRefereeEdit from '../views/user/outReferees/details'
import OutRefereeList from '../views/user/outReferees/list'
import ClubM from '../views/user/club'
import Clubs from '../views/user/club/list'
import ClubEdit from '../views/user/club/detail'
import ClubPlayerList from '../views/user/club/player-list'
import ApplicationList from '../views/user/club/application-list'
import SelectionManage from '../views/user/selection-manage'

import Leagues from '../views/league/match/list'
import LeagueM from '@/views/league/match/index'
import LeagueEdit from '../views/league/match/details'
import LeagueReferees from '@/views/league/match/referees'
import LeagueGroups from '@/views/league/match/group/list'
import LeagueGroupEdit from '@/views/league/match/group/details'
import LeagueGroupM from '@/views/league/match/group/index'
import LeagueGroupTeams from '@/views/league/match/group/teams'
import LeagueGroupTeamsM from '@/views/league/match/group/player/index'
import LeagueGroupTeamPlayers from '@/views/league/match/group/player/list'
import LeagueGroupGames from '@/views/league/match/group/games'
import LeagueGroupGamesM from '@/views/league/match/group/score/index'
import LeagueGroupGameScore from '@/views/league/match/group/score/list'
import LeagueGroupGameEdit from '@/views/league/match/group/score/game'
import Teams from '../views/league/teams'
import Games from '../views/league/games'
import StatsExport from '../views/league/stats-export'
import OldLeagues from '../views/league/old-league/list'
import OldLeaguesM from '../views/league/old-league/index'
import OldLeagueReferees from '../views/league/old-league/referees'
import OldLeagueRefereeDetails from '../views/league/old-league/details'
import BatchUpdateDetail from '../views/league/old-league/batch-details'
import OldLeagueGameList from '../views/league/old-league/games'
import RefereeStats from '../views/league/referee-stats'
import LeagueManage from '../views/league/league-manage'
import LeagueMatchManage from '../views/league/league-match-manage'

// 内容管理
import CmsContentList from '@/views/cms/activity/list'
import CmsContentM from '@/views/cms/activity/index'
import CmsContentEdit from '@/views/cms/activity/details'

import MediaImageList from '@/views/media/image/list'
import MediaImageM from '@/views/media/image/index'
import MediaImageEdit from '@/views/media/image/details'

// player stats
import PlayerStatsRouter from '@/router/modules/player-stats'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
  }
**/
export const constantRouterMap = [
  { path: '/login', component: Login, hidden: true },
  { path: '/member-list', component: PaidMember, hidden: true },
  { path: '/players-data-list', component: PlayersDataList, hidden: true },
  { path: '/player-years-list', component: PlayerYearList, hidden: true },
  { path: '/player-games-list', component: PlayerGamesList, hidden: true },
  { path: '/player-games-list2', component: PlayerGamesList2, hidden: true },
  { path: '/player-teams-list', component: PlayerTeamsList, hidden: true },
  { path: '/player-matches-list', component: PlayerMatchesList, hidden: true },
  { path: '/404', component: Error404, hidden: true },
  { path: '/401', component: Error401, hidden: true },
    
  // Player Stats
  PlayerStatsRouter,

  { path: '/', component: Layout, redirect: '/dashboard', name: '概况', hidden: true,
    children: [{
      path: 'dashboard',
      component: Dashboard
    }]
  },
]

export const asyncRouterMap = [
  {
    path: '/system',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: 'dashboard',
      roles: ['sys']
    },
    children: [
      {
        path: 'settings',
        component: Settings,
        name: 'SettingConfig',
        meta: {
          title: '系统设置',
          roles: ['sys-setting'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'admins',
        component: Admins,
        name: 'AdminList',
        meta: {
          title: '管理员列表',
          roles: ['sys-admin']
        }
      },
      {
        path: 'roles',
        component: Roles,
        name: 'RoleList',
        meta: {
          title: '角色管理',
          roles: ['sys-role']
        }
      },
      {
        path: 'fees',
        component: Fees,
        name: 'FeeList',
        meta: {
          title: '会费管理',
          roles: ['sys-fee']
        }
      },
      {
        path: 'schools',
        component: Schools,
        name: 'SchoolList',
        meta: {
          title: '学校管理',
          roles: ['sys-school']
        }
      },
      {
        path: '/protocol',
        component: ProtocolM,
        redirect: '/protocol/list',
        name: '协议管理',
        meta: {
          title: '协议列表',
          roles: ['sys-protocol']
        },
        children: [
          {
            path: 'list',
            component: Protocols,
            name: 'ProtocolList',
            meta: {
              title: '协议列表',
              roles: ['sys-protocol']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: ProtocolEdit,
            name: 'ProtocolEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['sys-protocol-edit']
            }
          }
        ]
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    alwaysShow: true,
    meta: {
      title: '会员管理',
      icon: 'peoples',
      roles: ['user']
    },
    children: [
      {
        path: 'list',
        component: Users,
        name: 'UserList',
        meta: {
          title: '会员列表',
          roles: ['user-member']
        }
      },
      {
        path: '/player',
        component: PlayerM,
        name: 'PlayerManager',
        redirect: '/player/list',
        meta: {
          title: '运动员管理',
          roles: ['user-player']
        },
        children: [
          {
            path: 'list',
            component: Players,
            name: 'PlayerList',
            meta: {
              title: '运动员列表',
              roles: ['user-player']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: Player,
            name: 'PlayerDetails',
            hidden: true,
            meta: {
              title: '详情信息',
              roles: ['user-player-read']
            }
          },
          {
            path: 'edit/:id(\\d+)',
            component: Player,
            name: 'PlayerEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['user-player-edit']
            }
          }
        ]
      },
      {
        path: '/coach',
        component: CoachM,
        name: 'CoachManager',
        redirect: '/coach/list',
        meta: {
          title: '教练员管理',
          roles: ['user-coach']
        },
        children: [
          {
            path: 'list',
            component: Coaches,
            name: 'CoachList',
            meta: {
              title: '教练员列表',
              roles: ['user-coach']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: CoachEdit,
            name: 'CoachDetails',
            hidden: true,
            meta: {
              title: '详情信息',
              roles: ['user-coach-read']
            }
          },
          {
            path: 'edit/:id(\\d+)',
            component: CoachEdit,
            name: 'CoachEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['user-coach-edit']
            }
          }
        ]
      },
      {
        path: '/in-referee',
        component: InRefereeM,
        name: 'InRefereeManage',
        meta: {
          title: '场内裁判员管理',
          roles: ['user-inReferee']
        },
        redirect: '/in-referee/list',
        children: [
          {
            path: 'list',
            component: InReferee,
            name: 'InRefereeList',
            meta: {
              title: '场内裁判员列表',
              roles: ['user-inReferee']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: InRefereeEdit,
            name: 'InRefereeDetails',
            hidden: true,
            meta: {
              title: '详情信息',
              roles: ['user-inReferee-read']
            }
          },
          {
            path: 'edit/:id(\\d+)',
            component: InRefereeEdit,
            name: 'InRefereeEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['user-inReferee-edit']
            }
          }
        ]
      },
      {
        path: '/out-referee',
        component: OutRefereeM,
        name: 'OutRefereeManage',
        meta: {
          title: '场外裁判员管理',
          roles: ['user-outReferee']
        },
        redirect: '/out-referee/list',
        children: [
          {
            path: 'list',
            component: OutRefereeList,
            name: 'OutRefereeList',
            meta: {
              title: '场外裁判员列表',
              roles: ['user-outReferee']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: OutRefereeEdit,
            name: 'OutRefereeDetails',
            hidden: true,
            meta: {
              title: '详情信息',
              roles: ['user-outReferee-read']
            }
          },
          {
            path: 'edit/:id(\\d+)',
            component: OutRefereeEdit,
            name: 'OutRefereeEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['user-outReferee-edit']
            }
          }
        ]
      },
      {
        path: '/club',
        component: ClubM,
        name: 'Club',
        meta: {
          title: '会员单位管理',
          roles: ['user-club']
        },
        redirect: '/club/list',
        children: [
          {
            path: 'list',
            component: Clubs,
            name: 'ClubList',
            meta: {
              title: '会员单位管理',
              roles: ['user-club']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: ClubEdit,
            name: 'ClubDetails',
            hidden: true,
            meta: {
              title: '详情信息',
              roles: ['user-club-read']
            }
          },
          {
            path: 'edit/:id(\\d+)',
            component: ClubEdit,
            name: 'ClubEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['user-club-edit']
            }
          },
          {
            path: 'application-list/:id(\\d+)',
            component: ApplicationList,
            name: 'ApplicationList',
            hidden: true,
            meta: {
              title: '申请列表',
              roles: ['user-club-apply']
            }
          },
          {
            path: 'player',
            component: ClubPlayerList,
            name: 'ClubPlayerList',
            hidden: true,
            meta: {
              title: '注册运动员',
              roles: ['user-club-edit']
            }
          }
        ]
      },
      {
        path: 'selection',
        component: SelectionManage,
        name: 'SelectionList',
        meta: {
          title: '入选管理',
          roles: ['selection-manage']
        }
      },
    ]
  },
  {
    path: '/league',
    component: Layout,
    redirect: '/league/index',
    alwaysShow: true,
    meta: {
      title: '赛事管理',
      icon: 'component',
      roles: ['league']
    },
    children: [
      {
        path: '/league',
        component: LeagueM,
        redirect: '/league/list',
        name: '联赛管理',
        meta: {
          title: '联赛列表',
          roles: ['league-match']
        },
        children: [
          {
            path: 'list',
            component: Leagues,
            name: 'Leagues',
            meta: {
              title: '联赛管理',
              roles: ['league-match']
            }
          },
          {
            path: 'details/:id(\\d+)',
            component: LeagueEdit,
            name: 'LeagueEdit',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['league-match-edit']
            }
          },
          {
            path: ':id(\\d+)/referees',
            component: LeagueReferees,
            name: 'LeagueReferees',
            hidden: true,
            meta: {
              title: '裁判管理',
              roles: ['league-match-referee']
            }
          },
          {
            path: '/league/:id(\\d+)/group',
            component: LeagueGroupM,
            redirect: '/league/:id(\\d+)/group/list',
            name: '组别管理',
            hidden: true,
            meta: {
              title: '组别管理',
              roles: ['league-match-group']
            },
            children: [
              {
                path: 'list',
                component: LeagueGroups,
                name: 'LeagueGroups',
                hidden: true,
                meta: {
                  title: '组别管理',
                  roles: ['league-match-group']
                }
              },
              {
                path: 'details',
                component: LeagueGroupEdit,
                name: 'LeagueGroupEdit',
                hidden: true,
                meta: {
                  title: '组别详情',
                  roles: ['league-match-group-edit']
                }
              },
              {
                path: '/league/:id(\\d+)/group/:gid(\\d+)/team',
                component: LeagueGroupTeamsM,
                redirect: '/league/:id(\\d+)/group/:gid(\\d+)/team/list',
                name: '球队管理',
                hidden: true,
                meta: {
                  title: '球队管理',
                  roles: ['league-match-group-team']
                },
                children: [
                  {
                    path: 'list',
                    component: LeagueGroupTeams,
                    name: 'LeagueGroupTeams',
                    hidden: true,
                    meta: {
                      title: '球队管理',
                      roles: ['league-match-group-team']
                    }
                  },
                  {
                    path: ':tid(\\d+)/players',
                    component: LeagueGroupTeamPlayers,
                    name: 'LeagueGroupTeamPlayers',
                    hidden: true,
                    meta: {
                      title: '球员管理',
                      roles: ['league-match-group-team-player']
                    }
                  }
                ]
              },
              {
                path: '/league/:id(\\d+)/group/:gid(\\d+)/game',
                component: LeagueGroupGamesM,
                redirect: '/league/:id(\\d+)/group/:gid(\\d+)/game/list',
                name: '赛程管理',
                hidden: true,
                meta: {
                  title: '赛程管理',
                  roles: ['league-match-game']
                },
                children: [
                  {
                    path: 'list',
                    component: LeagueGroupGames,
                    name: 'LeagueGroupGames',
                    hidden: true,
                    meta: {
                      title: '赛程管理',
                      roles: ['league-match-game']
                    }
                  },
                  {
                    path: ':mid(\\d+)/details',
                    component: LeagueGroupGameEdit,
                    name: 'LeagueGroupGameEdit',
                    hidden: true,
                    meta: {
                      title: '比赛详情',
                      roles: ['league-match-game-edit']
                    }
                  },
                  {
                    path: ':mid(\\d+)/scores',
                    component: LeagueGroupGameScore,
                    name: 'LeagueGroupGameScore',
                    hidden: true,
                    meta: {
                      title: '成绩管理',
                      roles: ['league-match-game-score']
                    }
                  }
                ]
              },
            ]
          },
        ]
      },
      {
        path: 'teams',
        component: Teams,
        name: 'TeamList',
        meta: {
          title: '球队管理',
          roles: ['league-team']
        }
      },
      {
        path: 'games',
        component: Games,
        name: 'GameList',
        meta: {
          title: '赛程管理',
          roles: ['league-game']
        }
      },
      {
        path: 'export',
        component: StatsExport,
        name: 'StatsExport',
        meta: {
          title: '数据导出',
          roles: ['league-stats-export']
        }
      },
      /*
      {
        path: '/league/out',
        component: OutLeaguesM,
        redirect: '/league/out/list',
        name: '外部联赛管理',
        meta: {
          title: '外部联赛',
          roles: ['league-out']
        },
        children: [
          {
            path: 'list',
            component: OutLeagues,
            name: 'OutLeagueList',
            meta: {
              title: '外部联赛管理',
              roles: ['league-out']
            }
          },
          {
            path: ':id(\\d+)/referees',
            component: OutLeagueReferees,
            name: 'OutLeagueRefereeList',
            hidden: true,
            meta: {
              title: '裁判统计',
              roles: ['league-out-referee']
            }
          },
          {
            path: ':id(\\d+)/referee-add',
            component: OutLeagueRefereeDetails,
            name: 'OutLeagueRefereeAdd',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['league-out-referee-add']
            }
          },
          {
            path: ':id(\\d+)/referee-update/:gameId(\\d+)',
            component: OutLeagueRefereeDetails,
            name: 'OutLeagueRefereeAdd',
            hidden: true,
            meta: {
              title: '详情编辑',
              roles: ['league-out-referee-update']
            }
          }
        ]
      }, */
      {
        path: 'referee-stats',
        component: RefereeStats,
        name: 'RefereeStatsList',
        meta: {
          title: '裁判统计',
          roles: ['league-referee-stats']
        },
      },
      {
        path: 'league-referee-game-list/:refereeId(\\d+)/:uId(.+)',
        component: RefereeGameList,
        name: 'RefereeGameList',
        hidden: true,
        meta: {
          title: '裁判员比赛执裁列表',
          roles: ['league-referee-game-list']
        },
      },
      {
        path: 'referee-match-list/:refereeId(\\d+)/:uId(.+)',
        component: RefereeMatchList,
        name: 'RefereeMatchList',
        hidden: true,
        meta: {
          title: '裁判赛事执裁统计',
          roles: ['league-referee-game-list']
        }
      },
      {
        path: 'league-referee-match-type-list/:refereeId(\\d+)/:uId(.+)',
        component: RefereeMatchTypeList,
        name: 'RefereeMatchTypeList',
        hidden: true,
        meta: {
          title: '裁判员比赛类型执裁列表',
          roles: ['league-referee-match-type-list']
        }
      },
      {
        path: '/league-old',
        component: OldLeaguesM,
        redirect: '/league-old/list',
        meta: {
          title: '补录赛事',
          roles: ['league-old']
        },
        children: [
          {
            path: 'list',
            component: OldLeagues,
            name: 'OldLeagueList',
            meta: {
              title: '补录赛事',
            }
          },
          {
            path: ':id(\\d+)/referees',
            component: OldLeagueReferees,
            name: 'OldLeagueRefereeList',
            hidden: true,
            meta: {
              title: '裁判统计',
            }
          },
          {
            path: ':id(\\d+)/referee-add',
            component: OldLeagueRefereeDetails,
            name: 'OldLeagueRefereeAdd',
            hidden: true,
            meta: {
              title: '详情编辑',
            }
          },
          {
            path: ':id(\\d+)/referee-update/:gameId(\\d+)',
            component: OldLeagueRefereeDetails,
            name: 'OldLeagueRefereeUpdate',
            hidden: true,
            meta: {
              title: '详情编辑',
            }
          },
          {
            path: ':id(\\d+)/referee-batch-update',
            component: BatchUpdateDetail,
            name: 'BatchUpdateDetail',
            hidden: true,
            meta: {
              title: '详情编辑',
            }
          },
          {
            path: ':id(\\d+)/game-list',
            component: OldLeagueGameList,
            name: 'OldLeagueGameList',
            hidden: true,
            meta: {
              title: '补录赛程',
            }
          }
        ]
      },
      {
        path: 'leagues',
        component: LeagueManage,
        name: 'LeagueManage',
        meta: {
          title: '联盟管理',
          roles: ['league-manage']
        }
      },
      {
        path: 'matches',
        component: LeagueMatchManage,
        name: 'LeagueMatchManage',
        meta: {
          title: '联盟赛事',
          roles: ['league-match-manage']
        }
      },
    ]
  },

  {
    path: '/cms',
    component: Layout,
    meta: {
      title: '内容管理',
      icon: 'clipboard',
      roles: ['cms']
    },
    children: [
      {
        path: '/cms/activity',
        component: CmsContentM,
        redirect: '/cms/activity/list',
        name: '赛事活动',
        meta: {
          title: '活动列表',
          roles: ['cms-activity']
        },
        children: [
          {
            path: '/cms/activity/list',
            component: CmsContentList,
            name: 'CmsContentList',
            meta: {
              title: '赛事活动',
              forumId: 2,
              roles: ['cms-activity']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsContentCreate',
            hidden: true,
            meta: {
              title: '赛事活动创建',
              roles: ['cms-activity-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsContentEdit',
            hidden: true,
            meta: {
              title: '赛事活动编辑',
              roles: ['cms-activity-edit']
            }
          }
        ]
      },
      {
        path: '/cms/news',
        component: CmsContentM,
        redirect: '/cms/news/list',
        name: '新闻热点',
        meta: {
          title: '新闻列表',
          roles: ['cms-news']
        },
        children: [
          {
            path: '/cms/news/list',
            component: CmsContentList,
            name: 'CmsNewsList',
            meta: {
              title: '新闻热点',
              forumId: 3,
              roles: ['cms-news']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsNewsCreate',
            hidden: true,
            meta: {
              title: '新闻热点创建',
              roles: ['cms-news-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsNewsEdit',
            hidden: true,
            meta: {
              title: '新闻热点编辑',
              roles: ['cms-news-edit']
            }
          }
        ]
      },
      {
        path: '/cms/rules',
        component: CmsContentM,
        redirect: '/cms/rules/list',
        name: '规章规程',
        meta: {
          title: '规章规程',
          roles: ['cms-rules']
        },
        children: [
          {
            path: '/cms/rules/list',
            component: CmsContentList,
            name: 'CmsRulesList',
            meta: {
              title: '规章规程',
              forumId: 4,
              roles: ['cms-rules']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsRulesCreate',
            hidden: true,
            meta: {
              title: '规章规程创建',
              roles: ['cms-rules-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsRulesEdit',
            hidden: true,
            meta: {
              title: '规章规程编辑',
              roles: ['cms-rules-edit']
            }
          }
        ]
      },
      {
        path: '/cms/notice',
        component: CmsContentM,
        redirect: '/cms/notice/list',
        name: '活动公告',
        meta: {
          title: '活动公告',
          roles: ['cms-notice']
        },
        children: [
          {
            path: '/cms/notice/list',
            component: CmsContentList,
            name: 'CmsNoticeList',
            meta: {
              title: '活动公告',
              forumId: 5,
              roles: ['cms-notice']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsNoticeCreate',
            hidden: true,
            meta: {
              title: '活动公告创建',
              roles: ['cms-notice-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsNoticeEdit',
            hidden: true,
            meta: {
              title: '活动公告编辑',
              roles: ['cms-notice-edit']
            }
          }
        ]
      },
      {
        path: '/cms/learn',
        component: CmsContentM,
        redirect: '/cms/learn/list',
        name: '冰球百科',
        meta: {
          title: '冰球百科',
          roles: ['cms-learn']
        },
        children: [
          {
            path: '/cms/learn/list',
            component: CmsContentList,
            name: 'CmsLearnList',
            meta: {
              title: '冰球百科',
              forumId: 6,
              roles: ['cms-learn']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsLearnCreate',
            hidden: true,
            meta: {
              title: '冰球百科创建',
              roles: ['cms-learn-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsLearnEdit',
            hidden: true,
            meta: {
              title: '冰球百科编辑',
              roles: ['cms-learn-edit']
            }
          }
        ]
      },
      {
        path: '/cms/about',
        component: CmsContentM,
        redirect: '/cms/about/list',
        name: '关于BHA',
        meta: {
          title: '关于BHA',
          roles: ['cms-about']
        },
        children: [
          {
            path: '/cms/about/list',
            component: CmsContentList,
            name: 'CmsAboutList',
            meta: {
              title: '关于BHA',
              forumId: 7,
              roles: ['cms-about']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsAboutCreate',
            hidden: true,
            meta: {
              title: '关于BHA创建',
              roles: ['cms-learn-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: CmsContentEdit,
            name: 'CmsAboutEdit',
            hidden: true,
            meta: {
              title: '关于BHA编辑',
              roles: ['cms-about-edit']
            }
          }
        ]
      }
    ]
  },

  {
    path: '/media',
    component: Layout,
    meta: {
      title: '媒体管理',
      icon: 'documentation',
      roles: ['media']
    },
    children: [
      {
        path: '/media/image',
        component: MediaImageM,
        redirect: '/media/image/list',
        name: '图片广告',
        meta: {
          title: '图片列表',
          roles: ['media-image']
        },
        children: [
          {
            path: '/media/image/list',
            component: MediaImageList,
            name: 'MediaImageList',
            meta: {
              title: '图片广告',
              forumId: 0,
              roles: ['media-image']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: MediaImageEdit,
            name: 'MediaImageCreate',
            hidden: true,
            meta: {
              title: '图片广告创建',
              roles: ['media-image-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: MediaImageEdit,
            name: 'MediaImageEdit',
            hidden: true,
            meta: {
              title: '图片广告编辑',
              roles: ['media-image-edit']
            }
          }
        ]
      },
      {
        path: '/media/video',
        component: MediaImageM,
        redirect: '/media/video/list',
        name: '视频广告',
        meta: {
          title: '视频列表',
          roles: ['media-video']
        },
        children: [
          {
            path: '/media/video/list',
            component: MediaImageList,
            name: 'MediaVideoList',
            meta: {
              title: '视频广告',
              forumId: 1,
              roles: ['media-video']
            }
          },
          {
            path: 'create/:forumId(\\d+)',
            component: MediaImageEdit,
            name: 'MediaVideoCreate',
            hidden: true,
            meta: {
              title: '视频广告创建',
              roles: ['media-video-create']
            }
          },
          {
            path: 'details/:subjectId(\\d+)/:forumId(\\d+)',
            component: MediaImageEdit,
            name: 'MediaVideoEdit',
            hidden: true,
            meta: {
              title: '视频广告编辑',
              roles: ['media-video-edit']
            }
          }
        ]
      }
    ]
  },

  { path: '*', redirect: '/dashboard', hidden: true }

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
